import MakeAPayment from "./make-a-payment";
export default MakeAPayment;
